export const isPremiumOption = (faceplate) => {
    if (typeof faceplate.SK !== 'undefined') {
        return faceplate.SK.includes('PREMIUM');
    } else {
        return false;
    }
};
